/* unplugin-vue-components disabled */import { render } from "./MfNotificationsBadge.vue?vue&type=template&id=b321e284&scoped=true"
import script from "./MfNotificationsBadge.vue?vue&type=script&lang=js"
export * from "./MfNotificationsBadge.vue?vue&type=script&lang=js"

import "./MfNotificationsBadge.vue?vue&type=style&index=0&id=b321e284&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b321e284"]])

export default __exports__